import { NgClass, NgIf, NgOptimizedImage } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ISbStoriesParams } from '@storyblok/js';
import { DynamicModule } from 'ng-dynamic-component';
import { StoryblokLinkDirective } from 'src/app/directive/storyblok-link.directive';
import { StoryblokRichTextDirective } from 'src/app/directive/storyblok-richtext.directive';
import { StoryblokDirective } from 'src/app/directive/storyblok.directive';

@Component({
  selector: 'app-card',
  standalone: true,
  imports: [
    NgIf,
    NgClass,
    RouterModule,
    DynamicModule,
    StoryblokLinkDirective,
    StoryblokDirective,
    StoryblokRichTextDirective,
    NgOptimizedImage,
  ],
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss'],
})
export class CardComponent implements OnInit {
  @Input() name!: string;
  @Input() content!: any;
  @Input() link!: any;
  @Input() linktext!: any;
  @Input() image!: ISbStoriesParams;
  @Input() _editable!: string;
  @Input() aspect_ratio: number = 160;
  @Input() _uid!: string;
  @Input() component!: string;
  @Input() style: string = 'cover';
  @Input() width = 200;
  @Input() height = 250;

  ngOnInit() {
    if (this.content?.content.find((x: any) => x.content?.length > 0)) {
      this.content._more = true;
    }
  }
}
